module.exports = __webpack_public_path__ + "img/edit-dent-gray.21dceb93.svg";